import { render, staticRenderFns } from "./GeocercaIndex.vue?vue&type=template&id=29924adb"
import script from "./GeocercaIndex.vue?vue&type=script&lang=js"
export * from "./GeocercaIndex.vue?vue&type=script&lang=js"
import style0 from "./GeocercaIndex.vue?vue&type=style&index=0&id=29924adb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports